<template>
  <div class="profile-view">
    <div 
      class="profile-view--images"
      ref="container" 
    >
      <div class="profile-view--pagination">
        <div 
          v-for="index in user.images.length"
          :key="index"
          :class="[
            'profile-view--pagination-item',
            {
              'is-current-image': index - 1 === skip,
            }
          ]"
        >
      </div>
        <img :src="image">
      </div>
      <div 
        v-for="(image, imageIndex) in user.images"
        :key="`image-${imageIndex}`"
        class="profile-view--images-image"
        :style="{
          left: `${imageIndex * 100}%`,
          transform: `translate3d(-${100 * skip}%, 0, 0)`,
        }"
      >
        <img :src="image">
      </div>
    </div>

    <div 
      class="profile-view--infos"
    >
      <div class="is-aligned is-space-between m-horizontal-10">
        <h1>
          <b>{{ user.name }}</b>, {{ user.age }}
        </h1>

        <div class="is-centered">
          <i class="uil uil-ellipsis-h is-font-size-24"></i>
        </div>
      </div>

      <div class="is-grid m-top-15 m-horizontal-10">
        <div class="is-col-1"></div>
        <div class="is-col-11"><b>Profession :</b> {{ user.profession }}</div>

        <div class="is-col-1"></div>
        <div class="is-col-11"><b>Localisation :</b> {{ user.city }}</div>
      </div>

      <div class="is-grid m-top-15 m-horizontal-10">
        <div class="is-col-1 is-centered">
          <i class="uil uil-book-open"></i>
        </div>
        <div class="is-col-11">
          <i class="is-font-size-12">
            {{ user.books }}
          </i>
        </div>

        <div class="is-col-1 is-centered">
          <i class="uil uil-video"></i>
        </div>
        <div class="is-col-11">
          <i class="is-font-size-12">
            {{ user.movies }}
          </i>
        </div>

        <div class="is-col-1 is-centered">
          <i class="uil uil-heart"></i>
        </div>
        <div class="is-col-11">
          <i class="is-font-size-12">
            {{ user.hobbies }}
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { reactive, toRefs, computed, ref, onMounted, nextTick, onUnmounted, onBeforeUnmount, watch } from 'vue'
  import Hammer from 'hammerjs'
  import router from '@core/router'
  import benoit1 from '@assets/images/profile-1.jpg'
  import benoit2 from '@assets/images/profile-2.jpg'
  import dylan1 from '@assets/images/dylan1.jpg'
  import dylan2 from '@assets/images/dylan2.jpg'

  export default {
    setup () {
      const id = computed(() => router.currentRoute.value.params.id )
      const state = reactive({
        skip: 0,
        user: !id.value || id.value === 'benoit' ? {
          name: 'Benoît',
          age: 27,
          profession: 'Avocat',
          city: 'Paris',
          hobbies: `Chiller, s’allonger dans l’herbe, boire un café avec ma copine`,
          books: `L'amour dure trois ans`,
          movies: `Love actually`,
          images: [
            benoit1,
            benoit2,
          ]
        } : {
          name: 'Dylan',
          age: 28,
          profession: 'Restaurateur',
          city: 'Biarritz',
          hobbies: `-`,
          books: `-`,
          movies: `-`,
          images: [
            dylan1,
            dylan2,
          ]
        }
      })

      watch(() => state.user, () => state.skip = 0)

      const container = ref(null)

      let hammer = null

      function onSwipe (event) {
        const isRight = event.direction === Hammer.DIRECTION_LEFT
        const isLeft = event.direction === Hammer.DIRECTION_RIGHT
        const hasRight = state.skip < state.user.images.length - 1
        const hasLeft = state.skip > 0

        if (hasRight && isRight) {
          state.skip += 1 
        } else if (hasLeft && isLeft) {
          state.skip -= 1 
        }
      }

      onMounted(() => {
        nextTick(() => {
          hammer = new Hammer.Manager(container.value, {
            recognizers: [
              [Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }],
            ]
          })

          hammer.on('swipe', onSwipe)
        })
      })

      onBeforeUnmount(() => {
        hammer && hammer.destroy()
      })

      return {
        ...toRefs(state),
        container,
      }
    },
  }
</script>

<style lang="scss">
  .profile-view {
    position: fixed;
    top: 0px;
    left: 0px;
    height: calc(100vh - 100px);
    width: 100vw;
    z-index: 9;

    &--images {
      position: relative;
      height: 500px;
      width: 100%;
      max-width: 100vw;
      // overflow: auto;
      overflow: hidden;
      // transform: translate3d(0, -100px, 0);
      // border-bottom: solid 3px var(--color);

      &-image {
        position: absolute;
        top: 0px;
        height: 100%;
        width: 100%;
        transition: transform 0.3s $magic-animation;
        overflow: hidden;

        img {
          border-bottom: solid 3px var(--color);
        }

        // &:after {
        //   content: "";
        //   position: absolute;
        //   height: 3px;
        //   width: 100%;
        //   background: var(--color);
        //   left: 0px;
        //   bottom: 0px;
        // }
      }
    }

    &--pagination {
      position: absolute;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      bottom: 40px;
      height: 15px;
      z-index: 99999;

      &-item {
        position: relative;
        height: 15px;
        width: 15px;
        border-radius: 100%;
        margin: 0 5px;
        background: rgba(white, 0.5);

        &.is-current-image {
          background: rgba(white, 1);
        }
      }
    }

    &--infos {
      position: relative;
      // transform: translate3d(0, -85px, 0);
    }
  }
</style>